export * from './VoiceSampleList.container'



// WEBPACK FOOTER //
// src/features/Voices/VoiceSampleList/index.ts